var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"exhibition-hall-details-div"},[_c('div'),_c('div',{staticClass:"pic-div"},_vm._l((_vm.picList),function(imgPath,index){return _c('el-image',{key:index,staticClass:"pic-list",attrs:{"src":imgPath,"preview-src-list":[imgPath]}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }